import React from "react";
import { useParams } from "react-router-dom";
import "./Thanks.scss";
import { Container } from "react-bootstrap";

const Thanks = () => {
  const { email } = useParams<{ email: string }>();

  return (
    <Container className="thanks">
      <h3>Thanks for signing up!</h3>
      <div className="account-thanks">
        <p>
          We've sent an email to <strong>{email}</strong>. Check your email and click on the link to verify your
          account.
          </p>
          <p>Once you verify your email, look for a welcome message from us. Thanks again for joining!</p>
        <p style={{ fontSize: "14px" }}>
          Don't see the email? Contact{" "}
          <a href="mailto:support@inkedvoices.com">support@inkedvoices.com</a> for help.
        </p>
      </div>
    </Container>
  );
};

export default Thanks;